<template>
  <div id="save-button-wrap">
    <button id="save" @click="saveCharacter">Save</button>
    <button v-if="!noClear" id="clear" @click="clearCharacter">Clear</button>
    <p :style="saveStateStyle">{{ saveState }}</p>
  </div>
</template>

<script>
export default {
  name: 'SaveButtons',
  props: ['noClear'],
  data() {
    return {
      saveState: 'Saved',
      saveStateStyle: 'opacity: 0;'
    }
  },
  methods: {
    saveCharacter: function() {
      this.$store.commit('saveCharacter');
      this.saveStateStyle = 'opacity: 1;';
      setTimeout(() => {
        this.saveStateStyle = 'opacity: 0; transition: 2s;'
      }, 0);
    },
    clearCharacter: function() {
      this.$emit('clear');
    }
  }
}
</script>

<style lang="css">
  #save-button-wrap {
    margin: 1em 0 2em;
  }

  #save-button-wrap button {
    font-size: 24px;
    margin: 0.5em;
    padding: 0.3em 0.7em;
    border: none;
    border-radius: 3px;
    transition: 0.2s; 
  }

  #save-button-wrap #save {
    padding: 0.35em 0.75em;
    background: #73C482;
    color: white;
  }

  #save-button-wrap #save:focus {
    outline: none;
  }

  #save-button-wrap #save:active {
    background: rgb(87, 168, 102);
    outline: none;
  }

  #save-button-wrap #clear {
    background: white;
    border: 1px solid #657a8f;
  }

  #save-button-wrap #clear:focus {
    outline: none;
  }

  #save-button-wrap #clear:active {
    background: #c8d1db;
    outline: none;
  }

  #save-button-wrap p {
    text-align: center;
  }

</style>